export default __webpack_public_path__ + "media/images/fleche1-026055bd38e65e563c6f71833966038e.png";